<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<div class="flex flex-wrap">
			<span class="text-sm" v-for="(tag, index) in tags" :key="index">
				{{ tag }}
				<span v-if="index != tags.length - 1" class="text-sm mx-[10px]">|</span>
			</span>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import DjBox from "~/ui-kit/components/box/DjBox.vue";

export default defineComponent({
	name: "DjBoxTags",
	components: { DjBox },
	props: {
		title: {
			type: String,
		},
		tags: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
});
</script>
